module.exports = __webpack_public_path__ + "img/pencil-fill.309d66da.svg";